import React, { useState, useEffect } from "react";
import "../../Assets/css/ringsettings.css";
import "../../Assets/css/education.css";
import {
  Col,
  Container,
  Row,
  Form,
  InputGroup,
  FormControl,
  Table,
  Button,
} from "react-bootstrap";
import { Breadcrumbs, Typography } from "@material-ui/core";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Helmet } from "react-helmet";
import Slider from "rc-slider";
import "../../../node_modules/rc-slider/assets/index.css";
import "../../../node_modules/rc-tooltip/assets/bootstrap.css";
import { NavLink, useHistory } from "react-router-dom";
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import axios from "axios";
import {
  ErrorImg,
  base_url,
  currency,
  currencycode,
  isLogin,
  postHeader,
  setSteps,
  user,
} from "../../Helpers/request";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import Ringbildermenu from "../../Components/ringbildermenu";
import { toast } from "react-toastify";
import ReplayIcon from "@mui/icons-material/Replay";
import { isMobileOnly, isTablet } from "react-device-detect";
import { Skeleton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { cartlengthvalue } from "../../Reducer/cartReducer";
import { whishlistlength } from "../../Reducer/wishlistReducer";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ListIcon from "@mui/icons-material/List";
import AppsIcon from "@mui/icons-material/Apps";
import IonRangeSlider from 'react-ion-slider';
import { store } from "../../Store/store";
import { sessionId } from "../../Reducer/homeReducer";
import ShopStyle from '../../Assets/css/RingDiamondShop.module.css'
import { Link } from "react-router-dom/cjs/react-router-dom";
import RingStyle from "../Front/RingStyle";
import vline from '../../Assets/newImg/vline.png'
const { createSliderWithTooltip } = Slider;
const Range = createSliderWithTooltip(Slider.Range);






const RingSettingsDiamonds = (props) => {
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const history = useHistory();
  const session_Id = useSelector(state => state.persistedReducer.home.session_id);
  const [productCount, setProductCount] = useState(0);
  const [view, setView] = useState(1);
  const [page, setPage] = useState(1);
  const [diamondList, setDiamondList] = useState([]);
  const [shape, setShape] = useState(
    JSON.parse(sessionStorage.getItem("bw_d_filter"))?.shape
      ? JSON.parse(sessionStorage.getItem("bw_d_filter"))?.shape
      : ""
  );

  const [caratrange, setCaratrange] = useState([]);
  const [carat, setCarat] = useState(
    JSON.parse(sessionStorage.getItem("bw_d_filter"))?.carat
      ? JSON.parse(sessionStorage.getItem("bw_d_filter"))?.carat
      : []
  );
  const [pricerange, setPricerange] = useState([]);
  const [price, setPrice] = useState(
    JSON.parse(sessionStorage.getItem("bw_d_filter"))?.price
      ? JSON.parse(sessionStorage.getItem("bw_d_filter"))?.price
      : []
  );
  const [leavemouse, setLeavemouse] = useState(false);
  const [cut, setCut] = useState(
    JSON.parse(sessionStorage.getItem("bw_d_filter"))?.cut
      ? JSON.parse(sessionStorage.getItem("bw_d_filter"))?.cut
      : [0, 100]
  );
  const [cutdata, setCutdata] = useState(
    JSON.parse(sessionStorage.getItem("bw_d_filter"))?.cutdata
      ? JSON.parse(sessionStorage.getItem("bw_d_filter"))?.cutdata
      : []
  );
  const [color, setColor] = useState(
    JSON.parse(sessionStorage.getItem("bw_d_filter"))?.color
      ? JSON.parse(sessionStorage.getItem("bw_d_filter"))?.color
      : [0, 100]
  );
  const [colordata, setColordata] = useState(
    JSON.parse(sessionStorage.getItem("bw_d_filter"))?.colordata
      ? JSON.parse(sessionStorage.getItem("bw_d_filter"))?.colordata
      : []
  );
  const [clarity, setClarity] = useState(
    JSON.parse(sessionStorage.getItem("bw_d_filter"))?.clarity
      ? JSON.parse(sessionStorage.getItem("bw_d_filter"))?.clarity
      : [0, 100]
  );
  const [claritydata, setClaritydata] = useState(
    JSON.parse(sessionStorage.getItem("bw_d_filter"))?.claritydata
      ? JSON.parse(sessionStorage.getItem("bw_d_filter"))?.claritydata
      : []
  );
  const [fluorescence, setFluorescence] = useState(
    JSON.parse(sessionStorage.getItem("bw_d_filter"))?.fluorescence
      ? JSON.parse(sessionStorage.getItem("bw_d_filter"))?.fluorescence
      : [0, 100]
  );
  const [fluorescencedata, setFluorescencedata] = useState(
    JSON.parse(sessionStorage.getItem("bw_d_filter"))?.fluorescencedata
      ? JSON.parse(sessionStorage.getItem("bw_d_filter"))?.fluorescencedata
      : []
  );
  const [polish, setPolish] = useState(
    JSON.parse(sessionStorage.getItem("bw_d_filter"))?.polish
      ? JSON.parse(sessionStorage.getItem("bw_d_filter"))?.polish
      : [0, 100]
  );
  const [polishdata, setPolishdata] = useState(
    JSON.parse(sessionStorage.getItem("bw_d_filter"))?.polishdata
      ? JSON.parse(sessionStorage.getItem("bw_d_filter"))?.polishdata
      : []
  );
  const [symmetry, setSymmetry] = useState(
    JSON.parse(sessionStorage.getItem("bw_d_filter"))?.symmetry
      ? JSON.parse(sessionStorage.getItem("bw_d_filter"))?.symmetry
      : [0, 100]
  );
  const [symmetrydata, setSymmetrydata] = useState(
    JSON.parse(sessionStorage.getItem("bw_d_filter"))?.symmetrydata
      ? JSON.parse(sessionStorage.getItem("bw_d_filter"))?.symmetrydata
      : []
  );
  const [filter, setFilter] = useState([]);
  const [filtersuccess, setFiltersuccess] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [loader, setLoader] = useState(true);
  const [sortby, setSortby] = useState("");
  const [inputchange, setInputchange] = useState(false);
  const [filterCleared, setFilterCleared] = useState(true);
  const [diamond_type, setDiamond_type] = useState(window.location.pathname == "/diamonds/lab-grown-diamonds" ? 2 : 1);
  const [clearFdata, setClearFdata] = useState(false);
  const [pageContent, setPageContent] = useState("");

  const dispatch = useDispatch();
  useEffect(() => {
    if (props.location.pathname?.includes("/diamonds/lab-grown-diamonds")) {
      setDiamond_type(2);
      setCarat([]);
      setPrice([]);
    } else {
      setDiamond_type(1);
      setCarat([]);
      setPrice([]);
    }
    if (props.location.pathname?.includes("/diamonds/shape=")) {
      setShape(props.location.pathname?.replace("/diamonds/shape=", ""));
    } else if (props.location.pathname?.includes("/diamonds/lab-grown-diamonds/shape=")) {
      setShape(props.location.pathname?.replace("/diamonds/lab-grown-diamonds/shape=", ""));
    }
  }, [window.location.pathname]);

  console.log("diamond_typediamond_typediamond_type",diamond_type,shape)


  const clearFilter = () => {
    setFilterCleared(true)
    sessionStorage.removeItem("bw_d_filter");
    setShape("");
    setCarat([
      filter?.normal_filters?.carat?.min,
      filter?.normal_filters?.carat?.max,
    ]);
    setPrice([
      filter?.normal_filters?.price?.min,
      filter?.normal_filters?.price?.max,
    ]);
    setCut([0, 100]);
    setCutdata([]);
    setColor([0, 100]);
    setColordata([]);
    setClarity([0, 100]);
    setClaritydata([]);
    setFluorescence([0, 100]);
    setFluorescencedata([]);
    setPolish([0, 100]);
    setPolishdata([]);
    setSymmetry([0, 100]);
    setSymmetrydata([]);
    setSortby(filter?.sort_by[0]?.value);
    setClearFdata(!clearFdata);
  };
  useEffect(async () => {
    setSteps(1);
    setFiltersuccess(false);
    const data = {
      currency_code: currencycode,
      setting_id: JSON.parse(localStorage.getItem("bw-settingdata"))
        ? JSON.parse(localStorage.getItem("bw-settingdata"))?.product_id
        : "",
      diamond_type: diamond_type,
    };
    await axios
      .post(base_url + "/diamond/diamond_filter", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setFilter(res.data.data);
          setSortby(res.data.data?.sort_by[0]?.value);
          if (
            !JSON.parse(sessionStorage.getItem("bw_d_filter"))?.price.length
          ) {
            setPrice([
              res.data.data?.normal_filters?.price?.min,
              res.data.data?.normal_filters?.price?.max,
            ]);
          }
          if (
            !JSON.parse(sessionStorage.getItem("bw_d_filter"))?.carat.length
          ) {
            setCarat([
              res.data.data?.normal_filters?.carat?.min,
              res.data.data?.normal_filters?.carat?.max,
            ]);
          }
          res.data.data?.normal_filters?.shape?.map((val) =>
            val.selected == 1 ? setShape(val.value) : ""
          );
          setCaratrange(res.data.data?.normal_filters?.carat?.range)
          setPricerange(res.data.data?.normal_filters?.price?.range)
          setFiltersuccess(true);
          // diamondlistdata()
        }
      })
      .catch((error) => {
        console.log(error);
      });

    localStorage.removeItem("bw-gemstonedata");
    localStorage.removeItem("bw-fancycolordata");
  }, [diamond_type]);

  useEffect(() => {
    if (filtersuccess) {
      diamondlistdata();
    }
  }, [page, filtersuccess]);
  useEffect(() => {
    onchangesdata();
  }, [shape, sortby, inputchange, clearFdata, carat, price]);

  useEffect(() => {
    if (filtersuccess) {
      diamondlistdata();
    }
  }, [page]);

  const onchangesdata = () => {
    setPage(1);
    var data1 = {
      shape,
      carat,
      price,
      cutdata,
      colordata,
      claritydata,
      fluorescencedata,
      polishdata,
      symmetrydata,
      cut,
      color,
      clarity,
      fluorescence,
      polish,
      symmetry,
      sortby,
    };
    sessionStorage.setItem("bw_d_filter", JSON.stringify(data1));
    // setInterval(async () => {diamondlistdata(); }, 3000);
    // setTimeout(diamondlistdata, 2000);
    if (filtersuccess) {
      diamondlistdata();
    }
  };

  useEffect(async () => {
    if (!filterCleared) {
      await diamondlistdata()
    }
  }, [filterCleared])
  const diamondlistdata = async () => {
    setLoader(true);
    setDiamondList([]);
    var data = {
      currency_code: currencycode,
      start: (page - 1) * 16,
      length: 16,
      cut: cutdata,
      color: colordata,
      clarity: claritydata,
      flourescence: fluorescencedata,
      polish: polishdata,
      symmetry: symmetrydata,
      shape,
      price_to: price[1],
      price_from: price[0],
      carat_from: carat[0],
      carat_to: carat[1],
      sort_by: sortby,
      user_id: user.user_id ? user.user_id : "",
      session_id: session_Id,
      token: isLogin ? user.token : "",
      diamond_type: diamond_type,
    };
    await axios
      .post(base_url + "/diamond/diamond_list", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setPageContent(res.data);
          setTotalCount(res.data.data?.count);
          setDiamondList(res.data.data?.result);
          var count = (res.data.data?.count / 16).toFixed();
          if (count * 16 >= res.data.data?.count) {
            setProductCount(count);
          } else {
            setProductCount(Number(count) + 1);
          }
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const datasort = (obj, min, max) => {
    var data = Object.keys(obj)?.map((key) => [Number(key), obj[key]]);
    var result = [];
    var data1 = data
      .filter((val) => val[0] > min && val[0] <= max)
      ?.map((val) => result.push(val[1]));
    return result;
  };
  const handlecut = (value) => {
    if (value[0] != value[1]) {
      setCut(value);
      var obj = filter?.normal_filters?.cut;
      var data = datasort(obj, value[0], value[1]);
      setCutdata(data);
    }
  };
  const handlecolor = (value) => {
    if (value[0] != value[1]) {
      setColor(value);
      var obj = filter?.normal_filters?.color;
      var data = datasort(obj, value[0], value[1]);
      setColordata(data);
    }
  };
  const handleclarity = (value) => {
    if (value[0] != value[1]) {
      setClarity(value);
      var obj = filter?.normal_filters?.clarity;
      var data = datasort(obj, value[0], value[1]);
      setClaritydata(data);
    }
  };
  const handlefluorescence = (value) => {
    if (value[0] != value[1]) {
      setFluorescence(value);
      var obj = filter?.advance_filters?.fluorescence;
      var data = datasort(obj, value[0], value[1]);
      setFluorescencedata(data);
    }
  };
  const handlePolish = (value) => {
    if (value[0] != value[1]) {
      setPolish(value);
      var obj = filter?.advance_filters?.polish;
      var data = datasort(obj, value[0], value[1]);
      setPolishdata(data);
    }
  };
  const handleSymmetry = (value) => {
    if (value[0] != value[1]) {
      setSymmetry(value);
      var obj = filter?.advance_filters?.symmetry;
      var data = datasort(obj, value[0], value[1]);
      setSymmetrydata(data);
    }
  };
  const handleprice = (value) => {
    setPrice([value.from_value, value.to_value]);
  };
  const handlepriceinput = (i) => {
    var data = [];
    if (i == 0) {
      if (price[0] < filter?.normal_filters?.price?.min) {
        data = [filter?.normal_filters?.price?.min, price[1]];
      } else if (price[0] > filter?.normal_filters?.price?.max) {
        data = [filter?.normal_filters?.price?.max, price[1]];
      } else {
        data = [price[0], price[1]];
      }
    } else if (i == 1) {
      if (price[1] > filter?.normal_filters?.price?.max) {
        data = [price[0], filter?.normal_filters?.price?.max];
      } else if (price[1] < filter?.normal_filters?.price?.min) {
        data = [price[0], filter?.normal_filters?.price?.min];
      } else {
        data = [price[0], price[1]];
      }
    }
    console.log(data);
    if (data[0] < data[1]) {
      var data1 = [data[0], data[1]];
    } else {
      var data1 = [data[1], data[0]];
    }
    setPrice(data1);
    setInputchange(!inputchange);
  };
  const handlecarat = (value) => {
    setCarat([value.from_value, value.to_value]);
  };
  const handlecaratinput = (i) => {
    var data = [];
    if (i == 0) {
      if (carat[0] < filter?.normal_filters?.carat?.min) {
        data = [filter?.normal_filters?.carat?.min, carat[1]];
      } else if (carat[0] > filter?.normal_filters?.carat?.max) {
        data = [filter?.normal_filters?.carat?.max, carat[1]];
      } else {
        data = [carat[0], carat[1]];
      }
    } else if (i == 1) {
      if (carat[1] > filter?.normal_filters?.carat?.max) {
        data = [carat[0], filter?.normal_filters?.carat?.max];
      } else if (carat[1] < filter?.normal_filters?.carat?.min) {
        data = [carat[0], filter?.normal_filters?.carat?.min];
      } else {
        data = [carat[0], carat[1]];
      }
    }
    if (data[0] < data[1]) {
      var data1 = [Number(data[0]), Number(data[1])];
    } else {
      var data1 = [Number(data[1]), Number(data[0])];
    }
    setCarat(data1);
    setInputchange(!inputchange);
  };
  const handlePageChange = (e, value) => {
    setPage(value);
    window.scrollTo(0, 0);
  };

  $(document).ready(function () {
    $("#ringsettingtable").DataTable();
  });

  const addtowishlist = (product_id, wishindex) => {
    const data = {
      currency_code: currencycode,
      user_id: user.user_id ? user.user_id : "",
      session_id: session_Id,
      product_id: product_id?.stock_no,
      type: "diamond",
      token: isLogin ? user.token : "",
    };
    axios
      .post(base_url + "/order/add_to_wishlist", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          const productlist = diamondList?.map((obj, index) =>
            index == wishindex
              ? Object.assign(obj, { is_wishlist: res.data.data?.wishlist_id })
              : obj
          );
          setDiamondList(productlist);
          dispatch(whishlistlength(res.data.data?.count));
        } else if (res.data.status == 2) {
          localStorage.removeItem("bw-user");
          dispatch(whishlistlength(0));
          dispatch(cartlengthvalue(0));
          dispatch(sessionId(''));
          history.push("/");
          window.location.reload(true);
        } else {
          toast.error(res.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const [expanded, setExpanded] = React.useState(false);
  const handleChangeAccordion = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails.title}</title>
        <meta name="description" content={metaDetails.description}></meta>
        <meta name="keywords" content={metaDetails.keywords}></meta>
        <link rel="canonical" href={window.location.href}></link>
      </Helmet>

      {
        console.log("pageContent", pageContent)
      }

      {/* 
      <div className={ShopStyle.BannerTop}>
        <h3 className={ShopStyle.subTitle}>Loose Diamonds</h3>
        <h2 className={ShopStyle.Title}>Diamond Search</h2>
        <ul className={ShopStyle.BreadcrumbS}>
          <li><Link to='/'>Home</Link></li>
          <li>/</li>
          <li>Diamond Search</li>
        </ul>
      </div> */}

      <div className="sl_eng_pera_top_box">
        <Container>
          <Row>
            <Col>
              <div className="sl_pera_box">

                <div className={`div-with-fade contentWrapper ${isExpanded ? "fullDisplay" : ""}`}>
                  {
                    pageContent?.title && <div dangerouslySetInnerHTML={{ __html: pageContent?.title }} />
                  }

                  {
                    pageContent?.description && <div dangerouslySetInnerHTML={{ __html: pageContent?.description }} />
                  }


                </div>

                {
                  pageContent?.description &&
                  <button
                    onClick={() => setIsExpanded(!isExpanded)}
                    className="noBtn"
                  >
                    {isExpanded ? "Read Less" : "Read More"}
                  </button>
                }



              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Ringbildermenu location="diamond" />

      <div className="rcs_ringsetting_section mt-3">
        <Container fluid className="rcs_shap-wizard_container">
          <div className={ShopStyle.MainBoxRingDiamondShop}>
            <div className={ShopStyle.LeftContainer}>
              <div className={ShopStyle.titlebox}>
                <h3 className={ShopStyle.Title}>Filters</h3>
                <Button
                  variant="none"
                  onClick={clearFilter}
                  className={ShopStyle.ShowcaseClearFilter}
                >
                  <ReplayIcon /> Reset
                </Button>
              </div>


              <div className={ShopStyle.showcase_diamonds_page_top_btn}>
                <h4 className={ShopStyle.showcase_diamonds_page_top_btn_title}>Diamond</h4>
                <ul className="d-flex justify-content-between align-item-center">
                  <li>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        history.push("/diamonds");
                        clearFilter();
                        setFiltersuccess(false)
                        setDiamond_type(1);
                      }}
                      className={diamond_type == 1 ? ShopStyle.active : ""}
                    >

                      <svg width="22" height="30" viewBox="0 0 22 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.9548 11.732C17.9667 13.1369 20 16.093 20 19.4329C20 24.0898 16.0469 28.0005 11 28.0005C5.95309 28.0005 2 24.0898 2 19.4329C2 16.2385 3.85995 13.3953 6.65706 11.9245L5.5413 10.2562C2.23063 12.0777 0 15.505 0 19.4329C0 25.2692 4.92487 30.0005 11 30.0005C17.0751 30.0005 22 25.2692 22 19.4329C22 15.3875 19.634 11.8731 16.1588 10.0971L14.9548 11.732Z" fill="#607980" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.13943 6.4007V7.34632L8.47883 7.03375C8.66551 6.86186 9.12605 6.44027 9.50225 6.0969C9.87846 5.75352 10.1863 5.46865 10.1863 5.46382C10.1863 5.45901 9.72574 5.45508 9.16285 5.45508H8.13943V6.4007ZM11.8154 5.4637C11.8154 5.47607 13.8374 7.321 13.8509 7.321C13.8572 7.321 13.8623 6.90117 13.8623 6.38804V5.45508H12.8388C12.276 5.45508 11.8154 5.45895 11.8154 5.4637ZM9.80517 6.65671L8.62037 7.73678L9.81062 7.74201C10.4652 7.74489 11.5368 7.74489 12.1918 7.74201L13.3827 7.73678L12.2042 6.66247C11.556 6.0716 11.0176 5.58557 11.0078 5.58241C10.998 5.57922 10.4568 6.06266 9.80517 6.65671ZM6.62394 6.8172C6.14213 7.30981 5.74481 7.72052 5.74099 7.72989C5.73715 7.73926 6.13426 7.74692 6.62344 7.74692H7.51284V6.83424C7.51284 6.33227 7.50993 5.92156 7.50638 5.92156C7.50283 5.92156 7.10572 6.3246 6.62394 6.8172ZM14.4889 6.82939V7.74692H15.3765C15.8647 7.74692 16.2642 7.74177 16.2642 7.73548C16.2642 7.72536 14.888 6.30872 14.6008 6.02319L14.4889 5.91186V6.82939ZM5.67825 8.37164C5.69172 8.40359 9.77432 13.1836 9.78186 13.1763C9.78604 13.1722 9.30287 12.0881 8.70814 10.7672L7.62681 8.36552L6.64902 8.36024C6.11122 8.35734 5.67438 8.36247 5.67825 8.37164ZM8.35506 8.46186C8.38146 8.52041 8.98517 9.86205 9.69664 11.4433C10.4081 13.0245 10.995 14.3182 11.0009 14.3182C11.0068 14.3182 11.5936 13.0245 12.305 11.4433C13.0165 9.86205 13.6201 8.52041 13.6466 8.46186L13.6947 8.35538H11.0008H8.30704L8.35506 8.46186ZM14.3323 8.46186C14.1284 8.89798 12.2139 13.1705 12.2198 13.1762C12.2272 13.1835 16.3101 8.40348 16.3234 8.37191C16.3272 8.36282 15.892 8.35538 15.3562 8.35538H14.3821L14.3323 8.46186Z" fill="#607980" />
                        <path d="M13.6363 4.04184C12.6962 5.03077 11.4819 4.80576 10.9922 4.56964C11.0456 4.25852 11.2192 3.88443 11.2994 3.73627C11.7588 2.70289 12.9419 1.77785 13.4761 1.44451C11.5397 1.97231 10.645 4.34741 10.645 4.3613C10.645 3.66127 10.832 3.05106 10.9255 2.83346C11.3528 1.74452 12.4033 1.1019 12.8752 0.916706L15.6128 0C15.5273 0.633361 15.1142 1.67137 14.9183 2.1112C14.6513 2.91124 13.9524 3.73164 13.6363 4.04184Z" fill="#607980" />
                        <path d="M8.5964 4.23139C9.29905 5.12984 10.1383 4.70941 10.4701 4.38689C10.0111 3.0876 9.00628 2.37115 8.56127 2.17534C9.61056 2.25827 10.3882 3.523 10.6458 4.145C10.6177 3.95149 10.5326 3.61515 10.4936 3.47117C10.1539 2.10623 9.29905 1.79523 9.28734 1.77795C8.37389 1.38056 7.09741 1.38056 7.09741 1.36328C7.68764 3.20164 8.34267 4.04134 8.5964 4.23139Z" fill="#607980" />
                      </svg>
                      Earth-Mined
                    </Button>
                  </li>
                  <li>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        history.push("/diamonds/lab-grown-diamonds");
                        clearFilter();
                        setFiltersuccess(false)
                        setDiamond_type(2);
                      }}
                      className={diamond_type == 2 ? ShopStyle.active : ""}
                    >

                      <svg width="25" height="30" viewBox="0 0 25 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.2508 1.15571V2.31141L9.63648 1.92941C9.84862 1.71933 10.372 1.20407 10.7995 0.78441C11.227 0.364753 11.5768 0.016583 11.5768 0.0106835C11.5768 0.00480883 11.0534 0 10.4138 0H9.2508V1.15571ZM13.4281 0.0105348C13.4281 0.0256554 15.7258 2.28048 15.7412 2.28048C15.7482 2.28048 15.754 1.76737 15.754 1.14024V0H14.591C13.9514 0 13.4281 0.00473445 13.4281 0.0105348ZM11.1437 1.4686L9.79733 2.78863L11.1499 2.79502C11.8938 2.79854 13.1114 2.79854 13.8557 2.79502L15.2091 2.78863L13.8698 1.47564C13.1332 0.7535 12.5214 0.159485 12.5103 0.155618C12.4992 0.151726 11.8842 0.742568 11.1437 1.4686ZM7.52865 1.66475C6.98115 2.2668 6.52965 2.76875 6.5253 2.7802C6.52094 2.79165 6.9722 2.80102 7.52808 2.80102H8.53876V1.68557C8.53876 1.07207 8.53546 0.57012 8.53143 0.57012C8.52739 0.57012 8.07613 1.0627 7.52865 1.66475ZM16.4661 1.67965V2.80102H17.4748C18.0296 2.80102 18.4835 2.79473 18.4835 2.78704C18.4835 2.77467 16.9197 1.04329 16.5933 0.694331L16.4661 0.558271V1.67965ZM6.454 3.56454C6.46931 3.60358 11.1086 9.44559 11.1172 9.43662C11.1219 9.43166 10.5729 8.10673 9.89706 6.49232L8.66828 3.55705L7.55716 3.55061C6.94602 3.54706 6.44961 3.55333 6.454 3.56454ZM9.49583 3.67479L11.0204 7.3186C11.8288 9.25111 12.4958 10.8323 12.5025 10.8323C12.5091 10.8323 13.176 9.25111 13.9845 7.3186L15.5089 3.67479L15.5636 3.54466H12.5024H9.44126L9.49583 3.67479ZM16.2882 3.67479C16.0564 4.20781 13.8808 9.42953 13.8875 9.43655C13.896 9.44542 18.5356 3.60345 18.5507 3.56486C18.5551 3.55375 18.0605 3.54466 17.4517 3.54466H16.3447L16.2882 3.67479ZM17.2243 7.33667C20.6323 9.12487 23 12.7902 23 17.0847C23 23.1753 18.2379 28.0001 12.5 28.0001C6.76214 28.0001 2 23.1753 2 17.0847C2 12.9694 4.17425 9.43185 7.35462 7.57024L6.29688 5.8693C2.53478 8.09546 0 12.2842 0 17.0847C0 24.2177 5.59644 30.0001 12.5 30.0001C19.4036 30.0001 25 24.2177 25 17.0847C25 12.1406 22.3113 7.84537 18.3622 5.6748L17.2243 7.33667ZM11.6953 15.0002C12.3634 15.0002 12.905 14.4407 12.905 13.7504C12.905 13.0601 12.3634 12.5005 11.6953 12.5005C11.0272 12.5005 10.4856 13.0601 10.4856 13.7504C10.4856 14.4407 11.0272 15.0002 11.6953 15.0002ZM10.8889 16.6643C11.1116 16.6643 11.2921 16.4778 11.2921 16.2477C11.2921 16.0176 11.1116 15.8311 10.8889 15.8311C10.6662 15.8311 10.4856 16.0176 10.4856 16.2477C10.4856 16.4778 10.6662 16.6643 10.8889 16.6643ZM13.7126 16.2477C13.7126 16.4778 13.532 16.6643 13.3093 16.6643C13.0866 16.6643 12.9061 16.4778 12.9061 16.2477C12.9061 16.0176 13.0866 15.8311 13.3093 15.8311C13.532 15.8311 13.7126 16.0176 13.7126 16.2477ZM11.695 18.3323C11.9177 18.3323 12.0982 18.1457 12.0982 17.9156C12.0982 17.6856 11.9177 17.499 11.695 17.499C11.4723 17.499 11.2918 17.6856 11.2918 17.9156C11.2918 18.1457 11.4723 18.3323 11.695 18.3323ZM12.5028 26.6633C17.6248 26.6633 21.777 22.5853 21.777 17.5548C21.777 14.7362 19.8912 15.8768 17.3318 17.4248L17.3318 17.4248C15.3233 18.6395 12.9001 20.1051 10.648 20.1051C8.04843 20.1051 6.17645 18.1524 4.96313 16.8868C3.78581 15.6587 3.22864 15.0775 3.22864 17.5548C3.22864 22.5853 7.38084 26.6633 12.5028 26.6633ZM13.3113 24.1627C13.9794 24.1627 14.521 23.6031 14.521 22.9128C14.521 22.2225 13.9794 21.663 13.3113 21.663C12.6432 21.663 12.1016 22.2225 12.1016 22.9128C12.1016 23.6031 12.6432 24.1627 13.3113 24.1627ZM8.87321 22.4962C8.87321 22.9564 8.51215 23.3295 8.06676 23.3295C7.62137 23.3295 7.26031 22.9564 7.26031 22.4962C7.26031 22.036 7.62137 21.663 8.06676 21.663C8.51215 21.663 8.87321 22.036 8.87321 22.4962ZM17.3412 22.4984C18.0093 22.4984 18.5509 21.9388 18.5509 21.2485C18.5509 20.5582 18.0093 19.9986 17.3412 19.9986C16.6731 19.9986 16.1315 20.5582 16.1315 21.2485C16.1315 21.9388 16.6731 22.4984 17.3412 22.4984ZM15.3253 25.4141C15.3253 25.6441 15.1448 25.8307 14.9221 25.8307C14.6994 25.8307 14.5188 25.6441 14.5188 25.4141C14.5188 25.184 14.6994 24.9974 14.9221 24.9974C15.1448 24.9974 15.3253 25.184 15.3253 25.4141ZM11.4935 21.2483C11.6048 21.2483 11.6951 21.155 11.6951 21.04C11.6951 20.9249 11.6048 20.8317 11.4935 20.8317C11.3821 20.8317 11.2919 20.9249 11.2919 21.04C11.2919 21.155 11.3821 21.2483 11.4935 21.2483Z" fill="#607980" />
                      </svg>

                      Lab-Grown
                    </Button>
                  </li>
                </ul>
              </div>

              <div className={"rcs_diamond_filter_section rcs_diamond_filter_section_desktop " + ShopStyle.FilterBox}>
                <div className={ShopStyle.FilterBox_inner}>
                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={50}
                          height={35}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={90}
                          height={42}
                        />
                      )}
                    </>
                  ) : (
                    <h2 title="Diamond Shape" className={ShopStyle.FilterBoxTitle}>Select Diamond Shape</h2>
                  )}
                  <ul className={"action-area--soLSw table-align_filter--GVxiB " + ShopStyle.FilterBoxIcons}>
                    {!filtersuccess ? (
                      <>
                        {isTablet ? (
                          <Skeleton
                            variant="text"
                            style={{ transform: "unset" }}
                            animation="wave"
                            width={300}
                            height={35}
                          />
                        ) : (
                          <Skeleton
                            variant="text"
                            style={{ transform: "unset", marginTop: '10px' }}
                            animation="wave"
                            width={'100%'}
                            height={42}
                          />
                        )}
                      </>
                    ) : (
                      filter?.normal_filters?.shape?.map((val) => (
                        <li
                          data-qa="ShapeFilter-Round"
                          onClick={() =>
                            shape == val.value
                              ? setShape("")
                              : setShape(val.value)
                          }
                          className={
                            val.status
                              ? shape == val.value
                                ? "longFilter--VqAB5 item--YBPgi selected--Qs8si " + ShopStyle.active
                                : "longFilter--VqAB5 item--YBPgi"
                              : "longFilter--VqAB5 item--YBPgi diamond-filter-dis "
                          }
                        >
                          <span className="single-item-container--Xo5ic">
                            <span className={"title--jqbwB " + ShopStyle.shapeTitle}>{val.name}</span>
                            <div className="filtered--yd5Rg"></div>
                            <img src={val.icon}></img>
                            {/* <span className="icon-round  selectionIcon icon--qAfox"></span> */}
                          </span>
                        </li>
                      ))
                    )}
                  </ul>

                  {/* <Button className={ShopStyle.OtherShape} variant="none">
                    Other Shape
                    <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.99978 1.00071L1 4.00078L7.5 11L14 4.00007L12.0002 1L2.99978 1.00071ZM11.7323 1.5006L11.898 1.74878L10.0315 3.6151L8.52105 1.5006H11.7323ZM7.90687 1.5006L9.69299 4.00078H5.30701L7.09313 1.5006H7.90687ZM3.26774 1.5006H6.47895L4.96783 3.6151L3.10203 1.74949L3.26774 1.5006ZM1.63463 3.95001L2.81927 2.17394L4.64629 4.00078H1.68117L1.63463 3.95001ZM2.14656 4.50067H4.90296L6.44652 9.13157L2.14656 4.50067ZM7.5 10.2653L7.26871 10.0171L5.43041 4.50067H9.5703L7.73129 10.0171L7.5 10.2653ZM8.55348 9.13086L10.097 4.49996H12.8534L8.55348 9.13086ZM13.3654 3.95001L13.3181 4.00078H10.353L12.18 2.17394L13.3654 3.95001Z" fill="black" stroke="black" stroke-width="0.5" />
                    </svg>
                  </Button> */}
                </div>

                <div className={ShopStyle.FilterBox_inner + ' ' + ShopStyle.filterPadding}>
                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={50}
                          height={35}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={90}
                          height={42}
                        />
                      )}
                    </>
                  ) : (
                    <h2 title="Diamond Cut" className={ShopStyle.FilterBoxTitle}>Cut</h2>
                  )}
                  <div className="rcs_cut_slider">
                    {!filtersuccess ? (
                      <>
                        {isTablet ? (
                          <Skeleton
                            variant="text"
                            style={{ transform: "unset" }}
                            animation="wave"
                            width={300}
                            height={35}
                          />
                        ) : (
                          <Skeleton
                            variant="text"
                            style={{ transform: "unset", marginTop: '10px' }}
                            animation="wave"
                            width={'100%'}
                            height={42}
                          />
                        )}
                      </>
                    ) : (
                      <Slider.Range
                        onAfterChange={() => onchangesdata()}
                        min={0}
                        allowCross={false}
                        marks={filter?.normal_filters?.cut}
                        step={null}
                        onChange={handlecut}
                        value={cut}
                      />
                    )}
                  </div>
                </div>

                <div className={ShopStyle.FilterBox_inner + ' ' + ShopStyle.filterPadding}>
                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={50}
                          height={35}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={90}
                          height={42}
                        />
                      )}
                    </>
                  ) : (
                    <h2 title="Diamond Color" className={ShopStyle.FilterBoxTitle}>Color</h2>
                  )}

                  <div className="rcs_color_slider">
                    {!filtersuccess ? (
                      <>
                        {isTablet ? (
                          <Skeleton
                            variant="text"
                            style={{ transform: "unset" }}
                            animation="wave"
                            width={300}
                            height={35}
                          />
                        ) : (
                          <Skeleton
                            variant="text"
                            style={{ transform: "unset", marginTop: '10px' }}
                            animation="wave"
                            width={'100%'}
                            height={42}
                          />
                        )}
                      </>
                    ) : (
                      <Slider.Range
                        onAfterChange={() => onchangesdata()}
                        allowCross={false}
                        min={0}
                        marks={filter?.normal_filters?.color}
                        step={null}
                        onChange={handlecolor}
                        value={color}
                      />
                    )}
                  </div>

                </div>

                <div className={ShopStyle.FilterBox_inner}>
                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={50}
                          height={35}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={90}
                          height={42}
                        />
                      )}
                    </>
                  ) : (
                    <h2 title="Diamond Carat" className={ShopStyle.FilterBoxTitle}>Carat</h2>
                  )}


                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={300}
                          height={35}
                          className="pr-top-10"
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset", marginTop: '10px' }}
                          animation="wave"
                          width={'100%'}
                          height={42}
                        />
                      )}
                    </>
                  ) : (
                    <>
                      <div className="rcs_catat_slider">
                        {/* <Range
                          onAfterChange={() => onchangesdata()}
                          min={filter?.normal_filters?.carat?.min}
                          max={filter?.normal_filters?.carat?.max}
                          value={carat}
                          allowCross={false}
                          onChange={handlecarat}
                          tipFormatter={(value) => `${value}`}
                          range={range}

                        /> */}
                        <IonRangeSlider type="double"
                          min={filter?.normal_filters?.carat?.min}
                          max={filter?.normal_filters?.carat?.max}
                          values={caratrange}
                          // onChange={handlecarat}
                          onFinish={(e) => handlecarat(e)}
                          from={caratrange.indexOf(carat[0])}
                          to={caratrange.indexOf(carat[1])}
                        />
                      </div>
                      <ul className="rcs_price_range_input rcs_prince_input_diamond pt-3">
                        <li>
                          <InputGroup>
                            {/* <InputGroup.Text>{currency}</InputGroup.Text> */}
                            <FormControl
                              aria-label="Amount (to the nearest dollar)"
                              type="number"
                              step={0.01}
                              name="min"
                              min={0}
                              value={carat[0]}
                              onChange={(e) => {
                                if (caratrange.includes(e.target.value)) {
                                  setCarat([
                                    Number(e.target.value),
                                    Number(carat[1]),
                                  ])
                                } else {
                                  var ind = caratrange.find(val => { return val > e.target.value })
                                  caratrange.splice(caratrange.indexOf(ind), 0, e.target.value);
                                  setCarat([
                                    Number(e.target.value),
                                    Number(carat[1]),
                                  ])
                                }
                              }
                              }
                              onBlurCapture={() => handlecaratinput(0)}
                            />
                          </InputGroup>
                        </li>
                        <li>
                          <InputGroup>
                            {/* <InputGroup.Text>{currency}</InputGroup.Text> */}
                            <FormControl
                              aria-label="Amount (to the nearest dollar)"
                              type="number"
                              step={0.01}
                              min={0}
                              name="max"
                              value={carat[1]}
                              onChange={(e) => {
                                if (caratrange.includes(e.target.value)) {
                                  setCarat([
                                    Number(carat[0]),
                                    Number(e.target.value),
                                  ])
                                } else {
                                  var ind = caratrange.find(val => { return val > e.target.value })
                                  caratrange.splice(caratrange.indexOf(ind), 0, e.target.value);
                                  setCarat([
                                    Number(carat[0]),
                                    Number(e.target.value),
                                  ])
                                }
                              }
                              }
                              onBlurCapture={() => handlecaratinput(1)}
                            />
                          </InputGroup>
                        </li>
                      </ul>
                    </>
                  )}
                </div>

                <div className={ShopStyle.FilterBox_inner + ' ' + ShopStyle.filterPadding}>
                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={50}
                          height={35}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={90}
                          height={42}
                        />
                      )}
                    </>
                  ) : (
                    <h2 title="Diamond Clarity" className={ShopStyle.FilterBoxTitle}>Clarity</h2>
                  )}

                  <div className="rcs_color_slider">
                    {!filtersuccess ? (
                      <>
                        {isTablet ? (
                          <Skeleton
                            variant="text"
                            style={{ transform: "unset" }}
                            animation="wave"
                            width={300}
                            height={35}
                          />
                        ) : (
                          <Skeleton
                            variant="text"
                            style={{ transform: "unset", marginTop: '10px' }}
                            animation="wave"
                            width={'100%'}
                            height={42}
                          />
                        )}
                      </>
                    ) : (
                      <Slider.Range
                        onAfterChange={() => onchangesdata()}
                        allowCross={false}
                        min={0}
                        marks={filter?.normal_filters?.clarity}
                        step={null}
                        onChange={handleclarity}
                        value={clarity}
                      />
                    )}
                  </div>
                </div>

                <div className={ShopStyle.FilterBox_inner}>
                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={50}
                          height={35}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={90}
                          height={42}
                        />
                      )}
                    </>
                  ) : (
                    <h2 title="Diamond Price" className={ShopStyle.FilterBoxTitle}>Price</h2>
                  )}



                  {!filtersuccess ? (
                    <>
                      {isTablet ? (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset" }}
                          animation="wave"
                          width={300}
                          height={35}
                          className="pr-top-10"
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          style={{ transform: "unset", marginTop: '10px' }}
                          animation="wave"
                          width={'100%'}
                          height={42}
                        />
                      )}
                    </>
                  ) : (
                    <>
                      <div className="rcs_catat_slider">
                        {/* <Range
                          onAfterChange={() => onchangesdata()}
                          min={filter?.normal_filters?.price?.min}
                          max={filter?.normal_filters?.price?.max}
                          onChange={handleprice}
                          value={price}
                          tipFormatter={(value) => `${value}`}
                          allowCross={false}
                        /> */}
                        <IonRangeSlider type="double"
                          min={filter?.normal_filters?.price?.min}
                          max={filter?.normal_filters?.price?.max}
                          values={pricerange}
                          // onChange={handleprice}
                          onFinish={(e) => handleprice(e)}
                          from={pricerange.indexOf(price[0])}
                          to={pricerange.indexOf(price[1])}
                        />
                        {/* <Range allowCross={false} min={0} max={500000} defaultValue={[0, 500000]} /> */}
                      </div>
                      <Row className="mt-2">
                        <ul className="rcs_price_range_input rcs_prince_input_diamond">
                          <li className="rcs_price_range_input1">
                            <i>Min</i>
                            <InputGroup>
                              <InputGroup.Text>{currency}</InputGroup.Text>
                              <FormControl
                                aria-label="Amount (to the nearest dollar)"
                                type="int"
                                name="min"
                                value={price[0]}
                                onChange={(e) => {
                                  if (pricerange.includes(e.target.value)) {
                                    setPrice([
                                      Number(e.target.value),
                                      Number(price[1]),
                                    ])
                                  } else {
                                    var ind = pricerange.find(val => { return val > e.target.value })
                                    pricerange.splice(pricerange.indexOf(ind), 0, e.target.value);
                                    setPrice([
                                      Number(e.target.value),
                                      Number(price[1]),
                                    ])
                                  }
                                }
                                }
                                onBlurCapture={() => handlepriceinput(0)}
                              />
                            </InputGroup>
                          </li>
                          <li className="rcs_price_range_input1">
                            <i>Max</i>
                            <InputGroup>
                              <InputGroup.Text>{currency}</InputGroup.Text>
                              <FormControl
                                aria-label="Amount (to the nearest dollar)"
                                type="int"
                                name="max"
                                value={price[1]}
                                onChange={(e) => {
                                  if (pricerange.includes(e.target.value)) {
                                    setPrice([
                                      Number(price[0]),
                                      Number(e.target.value),
                                    ])
                                  } else {
                                    var ind = pricerange.find(val => { return val > e.target.value })
                                    pricerange.splice(pricerange.indexOf(ind), 0, e.target.value);
                                    setPrice([
                                      Number(price[0]),
                                      Number(e.target.value),
                                    ])
                                  }
                                }
                                }
                                onBlurCapture={() => handlepriceinput(1)}
                              />
                            </InputGroup>
                          </li>
                        </ul>
                      </Row>
                    </>
                  )}
                </div>


              </div>

              <div className="rcs_diamond_filter_section d-block d-md-none">
                <div
                  xs={12}
                  className="rcs_filter_accordion_sec rcs_filter_accordion_sec_diamond"
                >
                  <Accordion
                    expanded={expanded === "panel1"}
                    onChange={handleChangeAccordion("panel1")}
                  >
                    <AccordionSummary
                      className={ShopStyle.AdvaFilter}
                      style={{ width: "100%" }}
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography>
                        <span>Diamonds Filter</span>
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails className="pt-0 pb-0">
                      <div className={ShopStyle.FilterBox}>
                        <div className={ShopStyle.FilterBox_inner + ' '}>
                          <h2 title="Diamond Shape" className={ShopStyle.FilterBoxTitle}>Shape</h2>
                          <ul className={"action-area--soLSw table-align_filter--GVxiB rcs_gemstone_color_shape " + ShopStyle.FilterBoxIcons}>
                            {filter?.normal_filters?.shape?.map((val) => (
                              <li
                                data-qa="ShapeFilter-Round"
                                onClick={() =>
                                  shape == val.value
                                    ? setShape("")
                                    : setShape(val.value)
                                }
                                className={
                                  val.status
                                    ? shape == val.value
                                      ? "longFilter--VqAB5 item--YBPgi selected--Qs8si " + ShopStyle.active
                                      : "longFilter--VqAB5 item--YBPgi"
                                    : "longFilter--VqAB5 item--YBPgi diamond-filter-dis"
                                }
                              >
                                <span className="single-item-container--Xo5ic">
                                  <span className={"title--jqbwB " + ShopStyle.shapeTitle}>
                                    {val.name}
                                  </span>
                                  <div className="filtered--yd5Rg"></div>
                                  <img src={val.icon} alt="" />
                                  {/* <span className="icon-round  selectionIcon icon--qAfox"></span> */}
                                </span>
                              </li>
                            ))}
                          </ul>
                        </div>

                        <div className={ShopStyle.FilterBox_inner + ' ' + ShopStyle.filterPadding}>
                          <h2 title="Diamond Cut" className={ShopStyle.FilterBoxTitle}>Cut</h2>
                          <div className="rcs_cut_slider">
                            <Slider.Range
                              onAfterChange={() => onchangesdata()}
                              allowCross={false}
                              min={0}
                              marks={filter?.normal_filters?.cut}
                              step={null}
                              onChange={handlecut}
                              value={cut}
                            />
                          </div>
                        </div>

                        <div className={ShopStyle.FilterBox_inner + ' ' + ShopStyle.filterPadding}>
                          <h2 title="Diamond Color" className={ShopStyle.FilterBoxTitle}>Color</h2>
                          <div className="rcs_color_slider">
                            <Slider.Range
                              onAfterChange={() => onchangesdata()}
                              allowCross={false}
                              min={0}
                              marks={filter?.normal_filters?.color}
                              step={null}
                              onChange={handlecolor}
                              value={color}
                            />
                          </div>
                        </div>

                        <div className={ShopStyle.FilterBox_inner + ' '}>
                          <h2 title="Diamond Carat" className={ShopStyle.FilterBoxTitle}>Carat</h2>
                          <div className="rcs_catat_slider">
                            <IonRangeSlider type="double"
                              min={filter?.normal_filters?.carat?.min}
                              max={filter?.normal_filters?.carat?.max}
                              values={caratrange}
                              // onChange={handlecarat}
                              onFinish={(e) => handlecarat(e)}
                              from={caratrange.indexOf(carat[0])}
                              to={caratrange.indexOf(carat[1])}
                            />
                          </div>
                          <Row className="mt-2">
                            <ul className="rcs_price_range_input rcs_prince_input_diamond">
                              <li>
                                <InputGroup>
                                  {/* <InputGroup.Text>{currency}</InputGroup.Text> */}
                                  <FormControl
                                    aria-label="Amount (to the nearest dollar)"
                                    type="number"
                                    step={0.01}
                                    min={0}
                                    name="min"
                                    value={carat[0]}
                                    onChange={(e) => {
                                      if (caratrange.includes(e.target.value)) {
                                        setCarat([
                                          Number(e.target.value),
                                          Number(carat[1]),
                                        ])
                                      } else {
                                        var ind = caratrange.find(val => { return val > e.target.value })
                                        caratrange.splice(caratrange.indexOf(ind), 0, e.target.value);
                                        setCarat([
                                          Number(e.target.value),
                                          Number(carat[1]),
                                        ])
                                      }
                                    }
                                    }
                                    onBlurCapture={() => handlecaratinput(0)}
                                  />
                                </InputGroup>
                              </li>
                              <li>
                                <InputGroup>
                                  {/* <InputGroup.Text>{currency}</InputGroup.Text> */}
                                  <FormControl
                                    aria-label="Amount (to the nearest dollar)"
                                    type="number"
                                    step={0.01}
                                    name="max"
                                    min={0}
                                    value={carat[1]}
                                    onChange={(e) => {
                                      if (caratrange.includes(e.target.value)) {
                                        setCarat([
                                          Number(carat[0]),
                                          Number(e.target.value),
                                        ])
                                      } else {
                                        var ind = caratrange.find(val => { return val > e.target.value })
                                        caratrange.splice(caratrange.indexOf(ind), 0, e.target.value);
                                        setCarat([
                                          Number(carat[0]),
                                          Number(e.target.value),
                                        ])
                                      }
                                    }
                                    }
                                    onBlurCapture={() => handlecaratinput(1)}
                                  />
                                </InputGroup>
                              </li>
                            </ul>
                          </Row>
                        </div>


                        <div className={ShopStyle.FilterBox_inner + ' ' + ShopStyle.filterPadding}>
                          <h2 title="Diamond Clarity" className={ShopStyle.FilterBoxTitle}>Clarity</h2>
                          <div className="rcs_color_slider">
                            <Slider.Range
                              onAfterChange={() => onchangesdata()}
                              min={0}
                              allowCross={false}
                              marks={filter?.normal_filters?.clarity}
                              step={null}
                              onChange={handleclarity}
                              value={clarity}
                            />
                          </div>
                        </div>
                        <div className={ShopStyle.FilterBox_inner + ' '}>
                          <h2 title="Diamond Price" className={ShopStyle.FilterBoxTitle}>Price</h2>
                          <div className="rcs_catat_slider">
                            <IonRangeSlider type="double"
                              min={filter?.normal_filters?.price?.min}
                              max={filter?.normal_filters?.price?.max}
                              values={pricerange}
                              // onChange={handleprice}
                              onFinish={(e) => handleprice(e)}
                              from={pricerange.indexOf(price[0])}
                              to={pricerange.indexOf(price[1])}
                            />
                          </div>
                          <Row className="mt-2">
                            <ul className="rcs_price_range_input rcs_prince_input_diamond">
                              <li className="rcs_price_range_input1">
                                <InputGroup>
                                  <InputGroup.Text>{currency}</InputGroup.Text>
                                  <FormControl
                                    aria-label="Amount (to the nearest dollar)"
                                    type="int"
                                    name="min"
                                    value={price[0]}
                                    onChange={(e) =>
                                      setPrice([
                                        Number(e.target.value),
                                        Number(price[1]),
                                      ])
                                    }
                                    onBlurCapture={() => handlepriceinput(0)}
                                  />
                                </InputGroup>
                              </li>
                              <li className="rcs_price_range_input1">
                                <InputGroup>
                                  <InputGroup.Text>{currency}</InputGroup.Text>
                                  <FormControl
                                    aria-label="Amount (to the nearest dollar)"
                                    type="int"
                                    name="max"
                                    value={price[1]}
                                    onChange={(e) =>
                                      setPrice([
                                        Number(price[0]),
                                        Number(e.target.value),
                                      ])
                                    }
                                    onBlurCapture={() => handlepriceinput(1)}
                                  />
                                </InputGroup>
                              </li>
                            </ul>
                          </Row>
                        </div>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </div>
              </div>

              <div className="rcs_diamond_filter_section">
                <div
                  className="rcs_filter_accordion_sec rcs_filter_accordion_sec_diamond"
                >
                  <Accordion
                    expanded={expanded === "panel2"}
                    onChange={handleChangeAccordion("panel2")}
                  >
                    <AccordionSummary
                      className={ShopStyle.AdvaFilter}
                      style={{ width: "100%" }}
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography>



                        <span>Advance Filter</span>

                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div className={ShopStyle.FilterBox}>
                        <div className={ShopStyle.FilterBox_inner + ' ' + ShopStyle.filterPadding}>
                          <h2 title="Diamond Fluorescence" className={ShopStyle.FilterBoxTitle}>Fluor</h2>
                          <div className="rcs_fluorescence_slider">
                            <Slider.Range
                              onAfterChange={() => onchangesdata()}
                              allowCross={false}
                              min={0}
                              marks={filter?.advance_filters?.fluorescence}
                              step={null}
                              onChange={handlefluorescence}
                              value={fluorescence}
                            />
                          </div>
                        </div>

                        <div className={ShopStyle.FilterBox_inner + ' ' + ShopStyle.filterPadding}>
                          <h2 title="Diamond Polish" className={ShopStyle.FilterBoxTitle}>Polish</h2>
                          <div className="rcs_cut_slider">
                            <Slider.Range
                              onAfterChange={() => onchangesdata()}
                              allowCross={false}
                              min={0}
                              marks={filter?.advance_filters?.polish}
                              step={null}
                              onChange={handlePolish}
                              value={polish}
                            />
                          </div>
                        </div>

                        <div className={ShopStyle.FilterBox_inner + ' ' + ShopStyle.filterPadding}>
                          <h2 title="Diamond Symmetry" className={ShopStyle.FilterBoxTitle}>Symmetry</h2>
                          <div className="rcs_cut_slider">
                            <Slider.Range
                              onAfterChange={() => onchangesdata()}
                              allowCross={false}
                              min={0}
                              marks={filter?.advance_filters?.symmetry}
                              step={null}
                              onChange={handleSymmetry}
                              value={symmetry}
                            />
                          </div>
                        </div>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </div>

              </div>
            </div>

            {/* Right Box */}
            <div className={ShopStyle.RightContainer}>
              {/* <Row className="w-100 d-block m-auto">
                <Col xs={12} className="p-0">
                  <div className="rcs_diamond_content">
                    <h1>Find Diamonds Easily</h1>
                    {diamond_type == 1 ? (
                      <>
                        <p>
                          The Diamond Search Feature helps you deploy various
                          filters to help you find exactly what you're looking for.
                        </p>
                        <p>All diamonds are ethically mined and certified.</p>
                      </>
                    ) : (
                      <p>
                        The Diamond Search Feature helps you deploy various filters
                        to help you find exactly what you're looking for.
                      </p>
                    )}
                  </div>
                </Col>
              </Row> */}

              <div className="rcs_product_list_wrapper">
                <div className={"rcs_view " + ShopStyle.TopviewProductsBox}>
                  <div className={"rcs_mob_filter1 rcs_ring_setting_filter " + ShopStyle.TopviewProductsBoxLeft}>
                    {loader ? (
                      <>
                        <Skeleton
                          variant="text"
                          animation="wave"
                          className="m-auto"
                          width={150}
                          height={20}
                        />
                      </>
                    ) : (
                      <span>  {totalCount} Product(s) Found </span>
                    )}
                  </div>
                  <div className={ShopStyle.TopviewProductsBoxRight}>
                    <div className={"rcs_mob_filter1 rcs_ring_setting_filter1 " + ShopStyle.TopviewProductsviewIcon}>
                      <span className={ShopStyle.TopviewProductsBoxtitle}> View</span>
                      {/* <AppsIcon
                        className={view == 1 ? "active_grid" : " "}
                        onClick={() => setView(1)}
                      /> */}

                      <svg className={view == 1 ? "active_grid" : " "}
                        onClick={() => setView(1)} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H8.57143V8.57143H0V0ZM11.4286 0H20V8.57143H11.4286V0ZM8.57143 11.4286H0V20H8.57143V11.4286ZM11.4286 11.4286H20V20H11.4286V11.4286Z" fill="none" />
                      </svg>

                      <span style={{ borderRight: "1px solid #ccc" }}></span>
                      {/* <ListIcon
                        className={view == 2 ? "active_grid" : " "}
                        onClick={() => setView(2)}
                      /> */}
                      <svg className={view == 2 ? "active_grid" : " "}
                        onClick={() => setView(2)} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H4V4H0V0ZM6.00028 0H20.0003V4H6.00028V0ZM4 8.00014H0V12.0001H4V8.00014ZM0 16.0003H4V20.0003H0V16.0003ZM20.0003 8.00014H6.00028V12.0001H20.0003V8.00014ZM6.00028 16.0003H20.0003V20.0003H6.00028V16.0003Z" fill="none" />
                      </svg>
                    </div>
                    <img src={vline} alt="" className={ShopStyle.TopviewProductsVline} />
                    <div
                      className={
                        isMobileOnly
                          ? "rcs_sort_filter p-0 " + ShopStyle.TopviewProductsshortBy
                          : "rcs_sort_filter p-0 " + ShopStyle.TopviewProductsshortBy
                      }
                    >
                      <label>

                        <span className={ShopStyle.TopviewProductsshortByTitle}>Sort By
                          {/* <i>Featured</i> */}
                        </span>
                      </label>
                      <Form.Select
                        onChange={(e) => {
                          setSortby(e.target.value);
                          window.scrollTo(0, 0);
                        }}
                        value={sortby}
                        aria-label="Default select example"
                      >
                        {filter.sort_by?.map((val) => (
                          <option value={val.value}>{val.name}</option>
                        ))}
                      </Form.Select>
                    </div>
                  </div>
                </div>
              </div>


              {view == 2 ? (
                <Row className="w-100 d-block m-auto">
                  <Col xs={12} className="rcs_diamond_table p-0">
                    <Table
                      hover
                      responsive
                      size="sm"
                      className="rcs_diamonds_table"
                    >
                      <thead>
                        <tr>
                          <th>Shape</th>
                          <th>Carat</th>
                          {isMobileOnly ? ' ' :
                            <>
                              <th>Color</th>
                              <th>Clarity</th>
                              <th>Cut</th>
                              <th>Lab</th>
                            </>
                          }
                          <th>Price</th>
                          <th>{isMobileOnly ? ' ' : 'Wishlist'}</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {loader ? (
                          <>
                            {[...Array(15)].map((val) => (
                              <tr>
                                <td component="th" scope="row">
                                  <Skeleton
                                    variant="text"
                                    style={{
                                      transform: "unset",
                                      margin: "0 auto",
                                    }}
                                    animation="wave"
                                    width={110}
                                    height={30}
                                  />
                                </td>
                                <td>
                                  <Skeleton
                                    variant="text"
                                    style={{
                                      transform: "unset",
                                      margin: "0 auto",
                                    }}
                                    animation="wave"
                                    width={110}
                                    height={30}
                                  />
                                </td>
                                <td>
                                  <Skeleton
                                    variant="text"
                                    style={{
                                      transform: "unset",
                                      margin: "0 auto",
                                    }}
                                    animation="wave"
                                    width={110}
                                    height={30}
                                  />
                                </td>
                                <td>
                                  <Skeleton
                                    variant="text"
                                    style={{
                                      transform: "unset",
                                      margin: "0 auto",
                                    }}
                                    animation="wave"
                                    width={110}
                                    height={30}
                                  />
                                </td>
                                <td>
                                  <Skeleton
                                    variant="text"
                                    style={{
                                      transform: "unset",
                                      margin: "0 auto",
                                    }}
                                    animation="wave"
                                    width={110}
                                    height={30}
                                  />
                                </td>
                                <td>
                                  <Skeleton
                                    variant="text"
                                    style={{
                                      transform: "unset",
                                      margin: "0 auto",
                                    }}
                                    animation="wave"
                                    width={110}
                                    height={30}
                                  />
                                </td>
                                <td>
                                  <Skeleton
                                    variant="text"
                                    style={{
                                      transform: "unset",
                                      margin: "0 auto",
                                    }}
                                    animation="wave"
                                    width={110}
                                    height={30}
                                  />
                                </td>
                                <td>
                                  <Skeleton
                                    variant="text"
                                    style={{
                                      transform: "unset",
                                      margin: "0 auto",
                                    }}
                                    animation="wave"
                                    width={110}
                                    height={30}
                                  />
                                </td>
                                <td>
                                  <Skeleton
                                    variant="text"
                                    style={{
                                      transform: "unset",
                                      margin: "0 auto",
                                    }}
                                    animation="wave"
                                    width={110}
                                    height={30}
                                  />
                                </td>
                              </tr>
                            ))}
                          </>
                        ) : (
                          diamondList?.map((row, index) => (
                            <tr>
                              <td>{row.shape}</td>
                              <td>{row.weight}</td>
                              {isMobileOnly ? ' ' :
                                <>
                                  <td>{row.color}</td>
                                  <td>{row.clarity}</td>
                                  <td>{row.cut_grade}</td>
                                  <td>{row.lab}</td>
                                </>
                              }
                              <td style={{ fontWeight: "600" }}>
                                {currency}
                                {row.sale_price}
                              </td>
                              <td
                                title="Add to Wishlist"
                                style={{ cursor: "pointer", textAlign: 'center' }}
                              >
                                {row.is_wishlist == "0" ? (
                                  <FavoriteBorderIcon
                                    onClick={() => addtowishlist(row, index)}
                                  />
                                ) : (
                                  <FavoriteIcon
                                    onClick={() => addtowishlist(row, index)}
                                    className="animate__animated animate__heartBeat"
                                  />
                                )}
                              </td>
                              <td>
                                <Button
                                  onClick={() =>
                                    history.push(
                                      "/diamonds-details/" + row.stock_no
                                    )
                                  }
                                  variant="contained"
                                >
                                  Details
                                </Button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                    <Stack spacing={2} className="mt-3 mb-3 rcs_diamond_pagination">
                      <Pagination
                        count={productCount}
                        page={page}
                        onChange={handlePageChange}
                        shape="rounded"
                      />
                    </Stack>
                  </Col>
                </Row>
              ) : (
                <>
                  <Row>
                    {loader ? (
                      <>
                        {[...Array(15)].map((val) => (
                          <>
                            <Col lg={4} md={4} xs={6}>
                              <Skeleton
                                variant="text"
                                style={{
                                  transform: "unset",
                                  margin: "0 auto",
                                  marginBottom: "15px",
                                }}
                                animation="wave"
                                height={300}
                              />
                            </Col>
                          </>
                        ))}
                      </>
                    ) : (
                      diamondList.map((row, index) => (
                        <Col lg={4} md={4} xs={6} className={ShopStyle.Col_box}>
                          <div className="rcs_diamonds_grid_content">
                            {/* <span className="rcs_diamonds_grid_info" >
                                        <img src="/static/media/inquir.9a98e4da.svg" /></span> */}
                            <span
                              className="rcs_diamonds_grid_wishlist"
                              style={{ cursor: "pointer" }}
                            >

                            </span>
                            <div className={ShopStyle.HoverBox}>
                              <NavLink to={"/diamonds-details/" + row.stock_no}>
                                <img src={row.imagelink} id={row.stock_no} onError={() => ErrorImg(row.shape, row.stock_no)} alt="diamonds" className />
                              </NavLink>
                              <div className="rcs_product_tooltip">
                                {/* <span>
                                  <MoreVertOutlinedIcon />
                                </span> */}
                                <div className="rcs_product_tooltip_content">
                                  <div className="rcs_bg-slide">
                                    <div className={ShopStyle.HoverBoxIcons}>
                                      <div className={ShopStyle.HoverBoxWishlist}>
                                        {row.is_wishlist == "0" ? <svg onClick={() => addtowishlist(row, index)} className={ShopStyle.HoverBoxWishlist11} width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <g filter="url(#filter0_d_1_256)">
                                            <circle cx="43" cy="43" r="23" fill="white" />
                                          </g>
                                          <path d="M53.1494 34.8506C52.5629 34.2639 51.8667 33.7985 51.1003 33.481C50.334 33.1634 49.5126 33 48.6831 33C47.8535 33 47.0321 33.1634 46.2658 33.481C45.4994 33.7985 44.8032 34.2639 44.2167 34.8506L42.9997 36.0677L41.7826 34.8506C40.5981 33.6661 38.9915 33.0006 37.3163 33.0006C35.6411 33.0006 34.0346 33.6661 32.85 34.8506C31.6655 36.0352 31 37.6417 31 39.3169C31 40.9921 31.6655 42.5987 32.85 43.7833L34.0671 45.0003L42.9997 53.9329L51.9323 45.0003L53.1494 43.7833C53.7361 43.1968 54.2015 42.5006 54.519 41.7342C54.8366 40.9679 55 40.1465 55 39.3169C55 38.4874 54.8366 37.666 54.519 36.8997C54.2015 36.1333 53.7361 35.4371 53.1494 34.8506V34.8506Z" stroke="#14344A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                          <defs>
                                            <filter id="filter0_d_1_256" x="0" y="0" width="86" height="86" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                              <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                              <feOffset />
                                              <feGaussianBlur stdDeviation="10" />
                                              <feComposite in2="hardAlpha" operator="out" />
                                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_256" />
                                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_256" result="shape" />
                                            </filter>
                                          </defs>
                                        </svg> :
                                          <svg onClick={() => addtowishlist(row, index)} className={ShopStyle.HoverBoxWishlist21} width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g filter="url(#filter0_d_1_259)">
                                              <circle cx="43" cy="43" r="23" fill="#607980" />
                                            </g>
                                            <path d="M37.2813 32.0106C35.347 31.9071 33.4069 32.5587 31.9789 33.9959C29.1212 36.878 29.4201 41.7147 32.4778 44.796L33.4545 45.7791L42.3305 54.7204C42.5089 54.8995 42.7506 55 43.0026 55C43.2545 55 43.4962 54.8995 43.6747 54.7204L52.5469 45.7791L53.5236 44.796C56.5812 41.7147 56.8782 36.878 54.0186 33.9978C51.1608 31.1176 46.3649 31.4242 43.3091 34.5037L43.0007 34.8141L42.6922 34.5037C41.1634 32.9611 39.2176 32.1141 37.2813 32.0106Z" fill="white" />
                                            <defs>
                                              <filter id="filter0_d_1_259" x="0" y="0" width="86" height="86" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                                <feOffset />
                                                <feGaussianBlur stdDeviation="10" />
                                                <feComposite in2="hardAlpha" operator="out" />
                                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_259" />
                                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_259" result="shape" />
                                              </filter>
                                            </defs>
                                          </svg>
                                        }
                                      </div>
                                      <div className={ShopStyle.HoverBoxWishlist}>
                                        <NavLink to={"/diamonds-details/" + row.stock_no}>
                                          <svg className={ShopStyle.HoverBoxWishlist1} width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g filter="url(#filter0_d_1_251)">
                                              <circle cx="43" cy="43" r="23" fill="white" />
                                            </g>
                                            <path d="M54.9088 42.582C52.9428 38.311 48.4998 34 42.9998 34C37.4998 34 33.0568 38.311 31.0908 42.582C31.0309 42.7132 31 42.8558 31 43C31 43.1442 31.0309 43.2868 31.0908 43.418C33.0568 47.689 37.4998 52 42.9998 52C48.4998 52 52.9428 47.689 54.9088 43.418C54.9686 43.2868 54.9995 43.1442 54.9995 43C54.9995 42.8558 54.9686 42.7132 54.9088 42.582V42.582ZM42.9998 50C38.5888 50 34.8538 46.448 33.1098 43C34.8538 39.552 38.5888 36 42.9998 36C47.4108 36 51.1458 39.552 52.8898 43C51.1458 46.448 47.4108 50 42.9998 50Z" fill="#607980" />
                                            <path d="M42.9998 38C42.0109 38 41.0442 38.2932 40.2219 38.8427C39.3997 39.3921 38.7588 40.173 38.3804 41.0866C38.0019 42.0002 37.9029 43.0055 38.0958 43.9755C38.2888 44.9454 38.765 45.8363 39.4642 46.5355C40.1635 47.2348 41.0544 47.711 42.0243 47.9039C42.9942 48.0969 43.9995 47.9978 44.9132 47.6194C45.8268 47.241 46.6077 46.6001 47.1571 45.7779C47.7065 44.9556 47.9998 43.9889 47.9998 43C47.9982 41.6744 47.4709 40.4036 46.5335 39.4662C45.5962 38.5289 44.3254 38.0016 42.9998 38V38ZM42.9998 46C42.4064 46 41.8264 45.8241 41.333 45.4944C40.8397 45.1648 40.4552 44.6962 40.2281 44.1481C40.0011 43.5999 39.9416 42.9967 40.0574 42.4147C40.1732 41.8328 40.4589 41.2982 40.8784 40.8787C41.298 40.4591 41.8325 40.1734 42.4145 40.0576C42.9964 39.9419 43.5996 40.0013 44.1478 40.2284C44.696 40.4554 45.1645 40.8399 45.4942 41.3333C45.8238 41.8266 45.9998 42.4067 45.9998 43C45.9998 43.7956 45.6837 44.5587 45.1211 45.1213C44.5585 45.6839 43.7954 46 42.9998 46Z" fill="#607980" />
                                            <defs>
                                              <filter id="filter0_d_1_251" x="0" y="0" width="86" height="86" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                                <feOffset />
                                                <feGaussianBlur stdDeviation="10" />
                                                <feComposite in2="hardAlpha" operator="out" />
                                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_251" />
                                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_251" result="shape" />
                                              </filter>
                                            </defs>
                                          </svg>
                                          <svg className={ShopStyle.HoverBoxWishlist2} width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g filter="url(#filter0_d_1_262)">
                                              <circle cx="43" cy="43" r="23" fill="#607980" />
                                            </g>
                                            <path d="M54.91 42.58C52.94 38.31 48.5 34 43 34C37.5 34 33.06 38.31 31.09 42.58C31.0307 42.7121 31 42.8552 31 43C31 43.1448 31.0307 43.2879 31.09 43.42C33.06 47.69 37.5 52 43 52C48.5 52 52.94 47.69 54.91 43.42C54.9693 43.2879 55 43.1448 55 43C55 42.8552 54.9693 42.7121 54.91 42.58V42.58ZM43 48C42.0111 48 41.0444 47.7068 40.2221 47.1573C39.3999 46.6079 38.759 45.827 38.3806 44.9134C38.0022 43.9998 37.9031 42.9945 38.0961 42.0245C38.289 41.0546 38.7652 40.1637 39.4645 39.4645C40.1637 38.7652 41.0546 38.289 42.0245 38.0961C42.9945 37.9031 43.9998 38.0022 44.9134 38.3806C45.827 38.759 46.6079 39.3999 47.1573 40.2221C47.7068 41.0444 48 42.0111 48 43C47.9984 44.3256 47.4711 45.5964 46.5338 46.5338C45.5964 47.4711 44.3256 47.9984 43 48V48Z" fill="white" />
                                            <path d="M43 46C44.6569 46 46 44.6569 46 43C46 41.3431 44.6569 40 43 40C41.3431 40 40 41.3431 40 43C40 44.6569 41.3431 46 43 46Z" fill="white" />
                                            <defs>
                                              <filter id="filter0_d_1_262" x="0" y="0" width="86" height="86" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                                <feOffset />
                                                <feGaussianBlur stdDeviation="10" />
                                                <feComposite in2="hardAlpha" operator="out" />
                                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_262" />
                                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_262" result="shape" />
                                              </filter>
                                            </defs>
                                          </svg>
                                        </NavLink>
                                      </div>
                                    </div>
                                    <ul onClick={() => history.push("/diamonds-details/" + row.stock_no)}>
                                      <li className="rcs_item-lists">
                                        <div className="rcs_left-align">Item</div>
                                        <div className="rcs_center_align">:</div>
                                        <div className="rcs_right-align">
                                          {row.stock_no}
                                        </div>
                                      </li>
                                      <li className="rcs_item-lists">
                                        <div className="rcs_left-align">Carat</div>
                                        <div className="rcs_center_align">:</div>
                                        <div className="rcs_right-align">
                                          {row.weight}
                                        </div>
                                      </li>
                                      <li className="rcs_item-lists">
                                        <div className="rcs_left-align">Color</div>
                                        <div className="rcs_center_align">:</div>
                                        <div className="rcs_right-align">
                                          {row.color}
                                        </div>
                                      </li>
                                      <li className="rcs_item-lists">
                                        <div className="rcs_left-align">Clarity</div>
                                        <div className="rcs_center_align">:</div>
                                        <div className="rcs_right-align">
                                          {row.clarity}
                                        </div>
                                      </li>
                                      <li className="rcs_item-lists">
                                        <div className="rcs_left-align">Cut</div>
                                        <div className="rcs_center_align">:</div>
                                        <div className="rcs_right-align">
                                          {row.cut_grade}
                                        </div>
                                      </li>
                                      <li className="rcs_item-lists">
                                        <div className="rcs_left-align">Pol/sym</div>
                                        <div className="rcs_center_align">:</div>
                                        <div className="rcs_right-align">
                                          {row.polish}
                                        </div>
                                      </li>
                                      <li className="rcs_item-lists">
                                        <div className="rcs_left-align">
                                          Fluorescence
                                        </div>
                                        <div className="rcs_center_align">:</div>
                                        <div className="rcs_right-align">
                                          {row.fluorescence_color}
                                        </div>
                                      </li>
                                      {row.measurements == "" ? (
                                        ""
                                      ) : (
                                        <li className="rcs_item-lists">
                                          <div className="rcs_left-align">
                                            Measure
                                          </div>
                                          <div className="rcs_center_align">:</div>
                                          <div className="rcs_right-align">
                                            {row.measurements}
                                          </div>
                                        </li>
                                      )}
                                      {row.lab == "" ? (
                                        ""
                                      ) : (
                                        <li className="rcs_item-lists">
                                          <div className="rcs_left-align">lab</div>
                                          <div className="rcs_center_align">:</div>
                                          <div className="rcs_right-align">
                                            {row.lab}
                                          </div>
                                        </li>
                                      )}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>


                            <div className="rcs_product_info">
                              <NavLink to={"/diamonds-details/" + row.stock_no}>

                                <h3>{row.name}</h3>
                              </NavLink>
                              <p className="rcs_emailprice rcs_diamonds_price_s">

                                {currency}
                                {row.sale_price}
                              </p>

                            </div>
                          </div>
                        </Col>
                      ))
                    )}
                  </Row>
                  <Row className="mt-5 mb-3">
                    <Col lg={6} xs={12} className="pr-0 m-auto">
                      <div className="rcs_sorting_pagi">
                        <Stack
                          spacing={2}
                          className="mt-3 mb-3 rcs_diamond_pagination diamond_p"
                        >
                          <Pagination
                            count={productCount}
                            page={page}
                            onChange={handlePageChange}
                            shape="rounded"
                          />
                        </Stack>
                      </div>
                    </Col>
                  </Row>
                </>
              )}
            </div>
          </div>
        </Container>
      </div>

      <Container className="mb-4">
        <Row>
          <Col>
            {
              pageContent?.title1 &&
              <div className="sl_pera_box">
                <Accordion
                  expanded={expanded === "panel1"}
                  onChange={handleChange("panel1")}
                  className="box-shadow lj_faq_accordian "
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    className="lj_faq_Question_heading "
                  >
                    <div className="mbAll">
                      {
                        pageContent?.title1 && <div dangerouslySetInnerHTML={{ __html: pageContent?.title1 }} />
                      }

                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      {
                        pageContent?.description1 && <div dangerouslySetInnerHTML={{ __html: pageContent?.description1 }} />
                      }

                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </div>
            }


            <div className="sl_pera_box fAq_eng_Accordian_section text-left">
              {pageContent?.faq_heading && <div className="my-5 my-md-4 my-sm-4 my-xs-4 my-lg-5 text-center text-uppercase" dangerouslySetInnerHTML={{ __html: pageContent?.faq_heading }} />}

              {pageContent?.faq?.length > 0 && pageContent?.faq?.map((faq, index) => (
                <Accordion
                  key={index}
                  expanded={expanded === index}
                  onChange={handleChangeAccordion(index)}
                  className="lj_faq_accordian"
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`${index}-content`}
                    id={`${index}-header`}
                    className="lj_faq_Question_heading"
                  >
                    <div>
                      <h3 className="text-left">{faq.question}</h3>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className="lj_faq_Question_ans">{faq.answer}</Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default RingSettingsDiamonds;

